<template>
  <div>
    <my-asidebar v-bind:active-tab="'price'"> </my-asidebar>
    <section class="dashboard-area">
      <top-bar></top-bar>
      <div class="dashboard-content-wrap">
        <div class="dashboard-bread dashboard--bread dashboard-bread-2">
          <div class="container-fluid">
            <div class="row align-items-center">
              <div class="col-lg-6">
                <div class="breadcrumb-content">
                  <div class="section-heading">
                    <h2 class="sec__title font-size-30 text-white">Fiyatlandırma</h2>
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="breadcrumb-list text-right">
                  <ul class="list-items">
                    <li><a :href="basePath" class="text-white">Anasayfa</a></li>
                    <li><a :href="basePath+'/pricings'" class="text-white">Fiyatlandırma</a></li>
                    <li>Detay</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <price-detail></price-detail>
        <create-pricing-period-popup/>
      </div>
    </section>

  </div>
</template>

<script>
import TopBar from "../component/common/TopBar";
import MyAsidebar from "../component/common/MyAsidebar";
import PriceDetail from "../component/price/PriceDetail";
import CreatePricingPeriodPopup from "../component/booking/CreatePricingPeriodPopup";



export default {
  name: "PriceDetailPage",
  components: {CreatePricingPeriodPopup, PriceDetail, MyAsidebar, TopBar},
  computed:{
    basePath:{
      get(){
        return this.$store.getters.getBasePath
      }
    },
    panelRights: {
      get() {
        return this.$store.getters.getPanelRightsMap;
      }
    }
  },
  mounted() {
    if(!this.panelRights["PANEL_PAGE_PRICE_DETAIL"]) this.$router.push("/");
    this.$store.commit("setSelectedPricingPeriodId", 0);
    if(this.$route.params.id !== undefined && this.$route.params.id !== 'new') {
      this.$store.dispatch("loadPrice", this.$route.params.id)
    }else{
      this.$nextTick(()=>{
        this.$store.commit("setPrice",{id:null})
      })
    }
    this.$store.dispatch("loadCruiseList");
    this.$store.dispatch("loadCruise").then(()=>{
      this.$store.dispatch("loadRoomList")
    });
    this.$store.dispatch("loadMarketList");
    this.$store.dispatch("loadAdditionalServiceList");
    this.$store.dispatch("loadAdditionalServicePricesListByTemplateId", {templateId: this.$route.params.id});
  }
}
</script>

<style scoped>

</style>